import { Component, OnInit } from '@angular/core';
import { CoinId } from '../../../services/bodyAll';
import { WalletService } from '../../../services/wallet.service'
//import { AppComponent } from '../../../app.component';
import { Router, NavigationExtras } from '@angular/router';
import { ToastController } from '@ionic/angular';
import { ModalController, NavParams } from '@ionic/angular';

@Component({
  selector: 'app-currencies',
  templateUrl: './currencies.page.html',
  styleUrls: ['./currencies.page.scss'],
})
export class CurrenciesPage implements OnInit {
  textSearch
  currencies:CoinId[] = []
  currenciesAux:CoinId[] = []
  isModal

  constructor(
    public modalController: ModalController,
    public navParams: NavParams,
    public toastCtrl: ToastController,
    private router: Router,
    private walletService: WalletService,
    //private appComponent: AppComponent,

  ) {
    
    console.log(this.navParams.get('is_modal'))
    console.log(this.navParams.get('currencies'))
    this.isModal = this.navParams.get('is_modal')
    this.currencies = this.navParams.get('currencies')
  }

  ngOnInit() {
    this.getCurrencies()
  }

  
  //OPERACIONES
  getCurrencies(){
    this.currencies = this.navParams.get('currencies')
    this.currenciesAux = this.currencies
  }

  search(event){
    console.log("search(event")
    console.log(event.target.value)

    if(!event.target.value){
      this.currenciesAux = this.currencies
      return 
    }

    let text = event.target.value.toUpperCase()

    this.currenciesAux = this.currencies.filter(
      el => el.coin.includes(text) || el.name.includes(text)
    )

  }
  /**
   * FUNCITON TEMPORL PARA INICIAR TEST
   * @param Iproposal 
   */
   initByTest(){
    this.currencies = [{
      coin:'AED',
      name:'AED',
      description:'AED',
      status:true,
      icon:'AED',
      image:'AED',
      valuta:'AED'
    }, {
      coin:'AMD',
      name:'AMD',
      description:'AMD',
      status:true,
      icon:'AMD',
      image:'AMD',
      valuta:'AMD'
    }, {
      coin:'ARS',
      name:'ARS',
      description:'ARS',
      status:true,
      icon:'ARS',
      image:'ARS',
      valuta:'ARS'
    }, {
      coin:'AZN',
      name:'AZN',
      description:'AZN',
      status:true,
      icon:'AZN',
      image:'AZN',
      valuta:'AZN'
    }, {
      coin:'BDT',
      name:'BDT',
      description:'BDT',
      status:true,
      icon:'BDT',
      image:'BDT',
      valuta:'BDT'
    }, {
      coin:'COL',
      name:'COL',
      description:'COL',
      status:true,
      icon:'COL',
      image:'COL',
      valuta:'COL'
    }, {
      coin:'USD',
      name:'USD',
      description:'USD',
      status:true,
      icon:'USD',
      image:'USD',
      valuta:'USD'
    }, {
      coin:'EUR',
      name:'EUR',
      description:'EUR',
      status:true,
      icon:'EUR',
      image:'EUR',
      valuta:'EUR'
    }]
    this.currenciesAux = this.currencies
    
  }
  /**
   * seecction
   * @param currency 
   */

  async selectCurrency(currency){
    
    this.closeModal({currency: currency})
  }
  
  async showLongToast(msg, color='dark') {
    const toast = await this.toastCtrl.create({
      message: msg,
      color,
      duration: 2000,
    });
    return toast.present();
  }

  async closeModal(param=null){
    await this.modalController.dismiss(param)
  }
}
